import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { COLORS } from "../../globalvariables";

const paths = [
  // 1
  "M16.7188 61.7V71H0.918747V61.7H4.31875V20.3H0.71875L2.71875 11H13.8187V61.7H16.7188Z",

  // 0 (1er)
  "M35.4383 10.5993C38.1716 10.5993 40.4049 11.4659 42.1383 13.1993C43.9383 14.9326 44.8383 17.1659 44.8383 19.8993V61.6993C44.8383 64.3659 43.9383 66.5993 42.1383 68.3993C40.4049 70.1326 38.1716 70.9993 35.4383 70.9993H30.1383C27.4049 70.9993 25.1383 70.1326 23.3383 68.3993C21.6049 66.5993 20.7383 64.3659 20.7383 61.6993V19.8993C20.7383 17.1659 21.6049 14.9326 23.3383 13.1993C25.0716 11.3993 27.3383 10.5326 30.1383 10.5993H35.4383ZM30.0383 61.1993C30.0383 61.5326 30.205 61.6993 30.5383 61.6993H35.2383C35.5716 61.6993 35.7383 61.5326 35.7383 61.1993V20.3993C35.7383 20.0659 35.5716 19.8993 35.2383 19.8993H30.7383C30.4049 19.8993 30.2383 20.0659 30.2383 20.3993L30.0383 61.1993Z",

  // 0 (2e)
  "M63.5633 10.5993C66.2966 10.5993 68.5299 11.4659 70.2633 13.1993C72.0633 14.9326 72.9633 17.1659 72.9633 19.8993V61.6993C72.9633 64.3659 72.0633 66.5993 70.2633 68.3993C68.5299 70.1326 66.2966 70.9993 63.5633 70.9993H58.2633C55.5299 70.9993 53.2633 70.1326 51.4633 68.3993C49.7299 66.5993 48.8633 64.3659 48.8633 61.6993V19.8993C48.8633 17.1659 49.7299 14.9326 51.4633 13.1993C53.1966 11.3993 55.4633 10.5326 58.2633 10.5993H63.5633ZM58.1633 61.1993C58.1633 61.5326 58.33 61.6993 58.6633 61.6993H63.3633C63.6966 61.6993 63.8633 61.5326 63.8633 61.1993V20.3993C63.8633 20.0659 63.6966 19.8993 63.3633 19.8993H58.8633C58.5299 19.8993 58.3633 20.0659 58.3633 20.3993L58.1633 61.1993Z",

  // 0 (3e)
  "M91.6883 10.5993C94.4216 10.5993 96.6549 11.4659 98.3883 13.1993C100.188 14.9326 101.088 17.1659 101.088 19.8993V61.6993C101.088 64.3659 100.188 66.5993 98.3883 68.3993C96.6549 70.1326 94.4216 70.9993 91.6883 70.9993H86.3883C83.6549 70.9993 81.3883 70.1326 79.5883 68.3993C77.855 66.5993 76.9883 64.3659 76.9883 61.6993V19.8993C76.9883 17.1659 77.855 14.9326 79.5883 13.1993C81.3216 11.3993 83.5883 10.5326 86.3883 10.5993H91.6883ZM86.2883 61.1993C86.2883 61.5326 86.455 61.6993 86.7883 61.6993H91.4883C91.8216 61.6993 91.9883 61.5326 91.9883 61.1993V20.3993C91.9883 20.0659 91.8216 19.8993 91.4883 19.8993H86.9883C86.6549 19.8993 86.4883 20.0659 86.4883 20.3993L86.2883 61.1993Z",

  // S
  "M114.613 50.9996V61.5996C114.613 61.9329 114.78 62.0996 115.113 62.0996H119.113C119.447 62.0996 119.613 61.9329 119.613 61.5996V43.5996L111.713 40.0996C111.113 39.8996 110.28 39.5663 109.213 39.0996C108.147 38.5663 107.18 37.7996 106.313 36.7996C105.513 35.7996 105.113 34.4329 105.113 32.6996V9.89961C105.113 7.09961 105.98 4.86628 107.713 3.19961C109.447 1.46628 111.713 0.599609 114.513 0.599609H119.713C122.513 0.599609 124.78 1.46628 126.513 3.19961C128.247 4.86628 129.113 7.09961 129.113 9.89961V24.6996L119.613 23.8996V10.3996C119.613 10.0663 119.447 9.89961 119.113 9.89961H115.113C114.78 9.89961 114.613 10.0663 114.613 10.3996V31.2996L122.513 34.7996C123.113 35.0663 123.947 35.4329 125.013 35.8996C126.08 36.3663 127.013 37.0996 127.813 38.0996C128.68 39.0996 129.113 40.4663 129.113 42.1996V62.0996C129.113 64.8996 128.247 67.1663 126.513 68.8996C124.78 70.5663 122.513 71.3996 119.713 71.3996H114.513C111.713 71.3996 109.447 70.5663 107.713 68.8996C105.98 67.1663 105.113 64.8996 105.113 62.0996V50.9996H114.613Z",

  // H
  "M143.141 1V31.2H148.841V1H158.341V71H148.841V40.5H143.141V71H133.641V10.3H132.141L133.141 1H143.141Z",

  // A (joue le son)
  "M170.84 71H161.34L166.74 10.3H164.94L165.94 1H184.24L190.44 71H180.94L179.84 59H171.94L170.84 71ZM172.74 49.7H179.04L175.94 14.9L172.74 49.7Z",

  // K
  "M193.895 71V10.3H192.395L193.395 1H203.395V20.5L212.095 1H222.595L209.995 29.2L223.595 71H213.095L203.395 41.2V71H193.895Z",

  // E
  "M248.321 61.7L247.521 71H225.621V10.3H224.121L225.121 1H248.321L247.321 10.3H235.121V31.3H246.321L245.321 40.6H235.121V61.7H248.321Z",
];

const animationDelays = [
  5.0, // 1
  1.1, // 0
  0.0, // 0
  2.4, // 0
  2.0, // S
  1.8, // H
  3.0, // A
  0.3, // K
  1.2, // E
];

// Délais pour mobile (tous à 0 pour animation immédiate)
const mobileAnimationDelays = [
  0.0, // 1
  0.1, // 0
  0.2, // 0
  0.3, // 0
  0.4, // S
  0.5, // H
  0.6, // A
  0.7, // K
  0.8, // E
];

const Logo = () => {
  const [resetTrigger, setResetTrigger] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [forceRender, setForceRender] = useState(0);
  const hasPlayedSound = useRef(false);
  const shouldPlaySoundNextCycle = useRef(false);
  const hasUserInteracted = useRef(false);
  const logoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Forcer le rendu initial sur mobile
  useEffect(() => {
    if (isMobile) {
      // Forcer immédiatement l'animation sur mobile
      setForceRender(Date.now()); // Utiliser timestamp pour garantir l'unicité
    } else {
      setForceRender(1);
    }
  }, [isMobile]);

  // Démarrage immédiat de l'animation sur mobile
  useEffect(() => {
    if (isMobile) {
      // Déclencher immédiatement sans délai
      const timer = setTimeout(() => {
        setResetTrigger((prev) => prev + 1);
      }, 100); // Très court délai juste pour s'assurer que le composant est monté
      return () => clearTimeout(timer);
    }
  }, [isMobile]);

  // Observer : est-ce que le logo est visible à l'écran ?
  useEffect(() => {
    // Sur mobile, considérer toujours comme visible
    if (isMobile) {
      setIsVisible(true);
      return;
    }
    
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );
    if (logoRef.current) observer.observe(logoRef.current);
    return () => {
      if (logoRef.current) observer.unobserve(logoRef.current);
    };
  }, [isMobile]);

  // Détection de l'interaction utilisateur (une seule fois)
  useEffect(() => {
    const handleInteraction = () => {
      if (!hasUserInteracted.current) {
        hasUserInteracted.current = true;
        shouldPlaySoundNextCycle.current = true;
      }
    };
    window.addEventListener("click", handleInteraction, { once: true });
    window.addEventListener("keydown", handleInteraction, { once: true });
    window.addEventListener("mousemove", handleInteraction, { once: true });
    return () => {
      window.removeEventListener("click", handleInteraction);
      window.removeEventListener("keydown", handleInteraction);
      window.removeEventListener("mousemove", handleInteraction);
    };
  }, []);

  // Redémarrage de l'animation après 9.5s
  useEffect(() => {
    const timeout = setTimeout(() => {
      setResetTrigger((prev) => prev + 1);
    }, 9500);
    return () => clearTimeout(timeout);
  }, [resetTrigger]);

  const playSound = (index) => {
    const E_INDEX = 4; // déclencher le son au moment du E (ou change l'index si besoin)
    if (
      index === E_INDEX &&
      shouldPlaySoundNextCycle.current &&
      !hasPlayedSound.current &&
      hasUserInteracted.current &&
      isVisible
    ) {
      setTimeout(() => {
        const audio = new Audio("/sounds/beep.mp3");
        audio.volume = 0.4;
        audio.play().catch((e) => console.warn("Audio error:", e));
      }, 6300); // délai de 2 secondes
      hasPlayedSound.current = true;
      shouldPlaySoundNextCycle.current = false;
    }
  };



  return (
    <div style={{ 
      width: '100%', 
      display: 'flex', 
      justifyContent: 'center',
      maxWidth: isMobile ? '280px' : '900px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 1
    }}>
      <svg 
        ref={logoRef} 
        viewBox="0 0 249 72" 
        width="100%" 
        height={isMobile ? "200" : "600"}
        style={{ maxWidth: '100%' }}
        key={`svg-${resetTrigger}`} // Forcer le re-render du SVG entier
      >
        {paths.map((d, i) => (
        <motion.path
        key={`${resetTrigger}-${forceRender}-${i}`}
        d={d}
            stroke={COLORS.primary}
        strokeWidth={isMobile ? 1.5 : 2}
            fill={COLORS.primary}
        initial={{ pathLength: 0, opacity: 0, fillOpacity: 0 }}
        animate={{
          pathLength: 1,
          opacity: 1,
          fillOpacity: i >= 4 ? 1 : 0, // SEULEMENT SHAKE (index 4 et +)
        }}
        exit={{ pathLength: 0, opacity: 0, fillOpacity: 0 }} // Forcer le reset à chaque cycle
        transition={{
          duration: 1.3,
          delay: animationDelays[i],
          ease: "easeInOut",
          fillOpacity: {
            delay: 6.3,
            duration: 0.8,
            ease: "easeInOut",
          },
        }}
        onAnimationStart={() => {
           if (i === 4) { // Déclencher le son sur le "S" (index 4)
             playSound(i);
           }
         }}
      />
        ))}
      </svg>
    </div>
  );
};

export default Logo;

